export default "__VITE_ASSET__CCBI7kII__"